import { lazy } from "react";
import { Switch } from "react-router";

import { RoutePathBuilder } from "@/common/builders/routePath";
import { Loadable } from "@/common/components/Loadable";
import AppRoute from "@/common/components/Routing/AppRoute";

import { ROUTE_PATH } from "../../common/constants/routing";
import AppGuards from "../BaseApp/AppGuards/AppGuards";
import { DynamicImportErrorFallback } from "../BaseApp/Error/DynamicImportErrorFallback";
import BaseAppContent from "./BaseAppContent";
import { DevAreaContent } from "./DevAreaContent";
import { DynamicImportErrorBoundary } from "./DynamicImportErrorBoundary";
import FleetAppContent from "./FleetAppContent";

// Use sync imports for hot paths and lazy loading for secondary paths.
// There was an issue that it took much time to init each area due to heavy init of module top-level lazy calls.
// const BaseAppContent = Loadable(lazy(() => import("./BaseAppContent")));
// const FleetAppContent = Loadable(lazy(() => import("./FleetAppContent")));
const FleetCustomerAppContent = Loadable(lazy(() => import("./FleetCustomerAppContent")));
const AdminAppContent = Loadable(lazy(() => import("./AdminAppContent")));

export default function Content() {
  // console.log("Content", moment(performance.now()).format("HH:mm:ss.SSS"));

  return (
    <>
      <AppGuards />

      {/* Global alerts */}
      {/* <Box sx={{ width: "100%" }}>
        <GlobalAlerts />
      </Box> */}

      <DynamicImportErrorBoundary fallback={<DynamicImportErrorFallback />}>
        <Switch>
          {/* Dev area */}
          <AppRoute
            path={RoutePathBuilder.toDefinition(ROUTE_PATH.APP_AREA_DEV)}
            render={() => <DevAreaContent />}
          />

          {/* FleetApp area */}
          <AppRoute
            path={RoutePathBuilder.toDefinition(ROUTE_PATH.APP_AREA_FLEET_APP)}
            render={() => <FleetAppContent />}
          />

          {/* FleetCustomerApp area */}
          <AppRoute
            path={RoutePathBuilder.toDefinition(ROUTE_PATH.APP_AREA_FLEET_CUSTOMER)}
            render={() => <FleetCustomerAppContent />}
          />

          {/* AdminApp area */}
          <AppRoute
            path={RoutePathBuilder.toDefinition(ROUTE_PATH.APP_AREA_ADMIN)}
            render={() => <AdminAppContent />}
          />

          {/* Base app (basic routes like auth, errors, etc) */}
          <AppRoute render={() => <BaseAppContent />} />

          {/* <AppRoute exact path='/' render={() => <RootRouteEntry />} /> */}

          {/* <AppRoute path="*" render={() => <NotFound />} /> */}
        </Switch>
      </DynamicImportErrorBoundary>
    </>
  );
}
